import { matchPath, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import router from 'constants/router'

const routePaths = (path) => (Array.isArray(path) ? path.filter(Boolean) : path ? [path] : [])

const findMatchedRoutes = (routes, pathname = global.location.pathname) => {
  return (routes || router).reduce((acc, route) => {
    const matched = routePaths(route.path).some((path) =>
      matchPath(pathname, {
        path,
        exact: route.exact,
      }),
    )

    if (matched) {
      acc.push(route)

      if (route?.routes) {
        acc = acc.concat(findMatchedRoutes(route.routes, pathname))
      }
    }

    return acc
  }, [])
}

export default findMatchedRoutes

/** Matches nav tree items when a descendant (not only direct path) is active — e.g. FAQ article under category. */
export const findMatchedNavRoutes = (routes, pathname = global.location.pathname) => {
  if (!routes?.length) {
    return []
  }

  return routes.reduce((acc, route) => {
    const childMatches = route.routes?.length ? findMatchedNavRoutes(route.routes, pathname) : []

    const selfMatched = route.path
      ? matchPath(pathname, { path: route.path, exact: route.exact })
      : null

    if (selfMatched) {
      acc.push(route, ...childMatches)
    } else if (childMatches.length > 0) {
      acc.push(...childMatches)
    }

    return acc
  }, [])
}

export const getLastMatchedRoute = (matchedRoutes) => {
  if (!Array.isArray(matchedRoutes) || matchedRoutes.length === 0) {
    return undefined
  }

  return matchedRoutes[matchedRoutes.length - 1]
}

export const getMatchedRoute = (routes, pathname = global.location.pathname) =>
  getLastMatchedRoute(findMatchedRoutes(routes, pathname))

export function useFindMatchedRoutes(routes) {
  const location = useLocation()
  const [matchedRoutes, setMatchedRoutes] = useState([])

  useEffect(() => {
    setMatchedRoutes(findMatchedRoutes(routes, location.pathname))
  }, [routes, location.pathname])

  return matchedRoutes
}
